import { FindParamsItems, Item } from '@domains';
import { createAction, props } from '@ngrx/store';

export enum ItemActionType {
  ClearItemsFindParams = '[Captain] Clear Items Find Params',
  ClearItems = '[Captain] Clear Items',
  GetItems = '[Item] Get Items',
  GetItemsSuccess = '[Item] Get Items Success',

  GetItem = '[Item] Get Item',
  GetItemSuccess = '[Item] Get Item Success',
}

export const clearItemsFindParams = createAction(ItemActionType.ClearItemsFindParams);
export const clearItems = createAction(ItemActionType.ClearItems);
export const getItems = createAction(ItemActionType.GetItems, props<{ findParams: FindParamsItems; keep?: boolean }>());
export const getItemsSuccess = createAction(
  ItemActionType.GetItemsSuccess,
  props<{
    resultsCount: number;
    results: Array<Item>;
  }>(),
);

export const getItem = createAction(ItemActionType.GetItem, props<{ id: string; expand?: string[] }>());
export const getItemSuccess = createAction(ItemActionType.GetItemSuccess, props<{ item: Item }>());
